import React from 'react'
import Header from './Header'
import _ from 'lodash'

export default class Container extends React.Component {
  render(){
    const auth = this.props.route.auth
    if(!auth.isAuthenticated()){
      auth.login()
    }
    let msg = _.get(this.props, 'msg')
    if(msg){
       msg = <h1 className='black-text'>{msg}</h1>
    }
    return(
      <div className='container-fluid mb20'>
        <div className='row'>
          <Header title= 'VMS' auth={auth}/>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            {msg}
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Container.js